import React, { FC } from 'react';

import Radio from '@zvuk-b2b/react-uikit/ui/Radio';

import { getDiscount, getIdSlug } from './utils';
import { PricePlanPeriodListProps } from './types';

import styles from './index.module.scss';

const PricePlanPeriodList: FC<PricePlanPeriodListProps> = ({
  pricePlan,
  currentPeriod,
  licensesCount,
  selectedPricePlanPeriodId,
  isPrimeAvailable,
  onPricePlanPeriodChange,
}) => (
  <div className={styles.pricePlanPeriodList}>
    {pricePlan?.periods.map((period) => {
      if (isPrimeAvailable && period.payFrequencyMonth === 12) {
        return <></>;
      }

      const currentDiscount = getDiscount(pricePlan, period, licensesCount);
      const isCurrentPeriod = currentPeriod?.id === period.id && selectedPricePlanPeriodId !== period.id;
      const idSlug = getIdSlug(isCurrentPeriod, period.payFrequencyMonth);

      return (
        <Radio
          key={`price_plan_period_item_${idSlug}`}
          elementId={`price_plan_period_item_${idSlug}`}
          isChecked={selectedPricePlanPeriodId === period.id}
          className={styles.periodItem}
          labelClassName={styles.discountLabel}
          onChange={() => onPricePlanPeriodChange({ period, rows: period.rows })}>
          <span>{period.title}</span>
          {currentDiscount > 0 && (
            <span
              data-testid={`price_plan_period_item_${idSlug}_discount`}
              className={styles.percent}>
              -{currentDiscount}%
            </span>
          )}
        </Radio>
      );
    })}
  </div>
);

export default React.memo(PricePlanPeriodList);
